import { useEffect, useState } from "react";
import { at } from "lodash";
import { useField } from "formik";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import {
  MarinerProfile,
  marinerSearchParams,
} from "../../common/MarinerProfile";
import { useGetMarinersQuery } from "../../redux/api/mariner";
import { JobRating } from "../JobOrder";

interface MarinerAutocompleteFieldProps {
  id: string;
  name: string;
  marinerRating: JobRating;
  setFieldValue: (
    field: string,
    value: any,
    shouldValidate?: boolean | undefined
  ) => void;
  onChangeCallback?: Function;
  disabled?: boolean;
}

const MarinerAutocompleteField = (props: MarinerAutocompleteFieldProps) => {
  const [searchParams, setSearchParams] = useState<marinerSearchParams>({
    search: "",
    ratings: [],
    vesselId: undefined,
    registered: undefined,
    compatibleWithRating: props.marinerRating,
    smis: "",
    veteran: undefined,
    trainingStatus: "",
    page: 0,
    size: 90,
    sortColumn: "firstName",
    sortDirection: "asc",
  });

  useEffect(() => {
    setSearchParams({
      ...searchParams,
      compatibleWithRating: props.marinerRating,
    });
    // do not include searchParams in the dependency array as it will lead to a loop and does not make sense here
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.marinerRating]);

  const { data: marinerProfiles, isLoading } =
    useGetMarinersQuery(searchParams);

  const { id, name, setFieldValue, onChangeCallback, disabled } = props;
  const [field, meta] = useField(props);
  const { value: selectedValue } = field;
  const [error] = at(meta, "error");

  return (
    <>
      {!isLoading && (
        <Autocomplete
          id={id}
          options={
            marinerProfiles?.content
              ? (marinerProfiles?.content as MarinerProfile[])
              : []
          }
          value={!!selectedValue && selectedValue !== "" ? selectedValue : null}
          clearOnEscape={true}
          clearOnBlur={true}
          onInputChange={(_: any, value: string) =>
            setSearchParams({ ...searchParams, search: value })
          }
          onChange={(_, value) => {
            if (onChangeCallback) {
              onChangeCallback(value);
            }
            setFieldValue(name, value);
          }}
          renderInput={(params) => (
            <TextField {...params} helperText={error} error={!!error} />
          )}
          isOptionEqualToValue={(option, value) => option.id === value.id}
          getOptionLabel={(profile: MarinerProfile) =>
            `${profile.firstName} ${profile.lastName} - ${
              profile.mmcId
            } - ${profile.rating?.substring(1)}`
          }
          disabled={disabled ? disabled : false}
        />
      )}
    </>
  );
};

export default MarinerAutocompleteField;
